/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Report_Reason_VideoInputs */

const en_us2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const pt_br2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo`)
};

const es_419_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const pt_pt2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo`)
};

const fr_fr2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

const de_de2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const it_it2_exercise_sheet_report_reason_video = /** @type {(inputs: Exercise_Sheet_Report_Reason_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Exercise_Sheet_Report_Reason_VideoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_report_reason_video = /** @type {((inputs?: Exercise_Sheet_Report_Reason_VideoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Report_Reason_VideoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_report_reason_video(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_report_reason_video(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_report_reason_video(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_report_reason_video(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_report_reason_video(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_report_reason_video(inputs)
	return en_us2_exercise_sheet_report_reason_video(inputs)
});
export { exercise_sheet_report_reason_video as "exercise-sheet.report_reason_video" }